module.exports = __webpack_public_path__ + "static/img/pendlebury.e2f7ae0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pendlebury.jpg
// module id = xJuh
// module chunks = 0